import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const NumberSection = styled('span')(
    ({ theme }: ParamsStyle) => `
        min-width: 30px;
        height: 30px;
        
        display: flex;
        padding-top: .25rem;
        align-items: center;
        justify-content: center;

        line-height: 1;
        font-weight: 700;
        font-size: 1.43rem;

        border-radius: 3.32023px;
        background: rgba(12, 28, 51, 0.2);
        color: ${theme?.palette.primary.main};
`);

export const ContainerPeriod = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        align-items: end;
        gap: .375rem;

        p {
            font-size: 1rem;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            flex-direction: column;
            align-items: start;

            p {
                font-size: .75rem;
            }
        }
`);

export const ContentPeriod = styled('div')(
    ({ theme }: ParamsStyle) => `
        gap: 1rem;
        width: 7.5rem;
        height: 7.5rem;
        display: flex;
        align-items: start;
        flex-direction: column;
        justify-content: center;

        border-radius: 8px;
        padding-left: 1.5rem;
        border: 2.26271px solid ${theme?.palette.primary.main};

        li {
            display: flex;
            align-items: center;
            list-style-type: none;

            input {
                width: 1rem;
                height: 1rem;
                accent-color: ${theme?.palette.primary.main};
            }

            label {
                cursor: pointer;
                padding-left: .5rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 8.625rem;
            height: 8.25rem;
        }
`);

export const ContentOptions = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        gap: 1.375rem;
        flex-direction: column;
        padding: 1rem 0 0 2.5625rem;
    
        li {
            display: flex;
            align-items: center;
            list-style-type: none;

            input {
                width: 1rem;
                height: 1rem;
                accent-color: ${theme?.palette.primary.main};
            }

            label {
                cursor: pointer;
                padding-left: .5rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            flex-direction: row;
        }
`);

export const Ul = styled('ul')(
    ({ theme }: ParamsStyle) => `
        padding-left: 1.5rem;
        margin-bottom: 1.4375rem;

        li {
            text-align: start;
            padding-bottom: .2rem;
            list-style-type: disc;

            p {
                font-size: .875rem;
                line-height: 1rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const ContentNewSearch = styled(Box)(
    ({ theme }: ParamsStyle) => `
        gap: 1.625rem;
        display: grid;
        align-items: end;
        margin-bottom: 1.5625rem;
        grid-template-columns: auto;

        #box-input {
            height: 4.125rem;
        }

        a {
            text-decoration: none;
            text-decoration: underline;
            color: #5D6779;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            grid-template-columns: 16.56rem auto;
        }
`);

export const ContentCards = styled('ul')(
    ({ theme }: ParamsStyle) => `
        display: grid;
        gap: .875rem;
        grid-template-columns: 1fr;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: grid;
            gap: 1rem;
            grid-template-columns: auto auto;
        }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;

    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);

export const PromotionalContent = styled(Box)(
    ({ theme }: ParamsStyle) => `
    padding: 1.5rem 1.5rem 1rem;
    text-align: center;

    .greeting {
        font-size: 1.125rem;
        color: ${theme?.palette.primary.main};
        margin-bottom: .75rem;
    }

    .description {
        font-size: .875rem;
        color: #555;
        line-height: 1.4;
        margin-bottom: 1.25rem;
    }

    .price-label {
        font-size: .875rem;
        color: #97C93D;
        font-weight: 600;
    }

    .price-container {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: .25rem;
        margin: .25rem 0;
    }

    .price-currency {
        font-size: 1rem;
        font-weight: 700;
        color: #97C93D;
    }

    .price-value {
        font-size: 3rem;
        font-weight: 700;
        color: #97C93D;
        line-height: 1;
    }

    .price-info {
        font-size: .8125rem;
        color: #777;
        margin-top: .5rem;
        line-height: 1.3;
    }
`);

export const PromotionalFooter = styled(Box)(
    ({ theme }: ParamsStyle) => `
    padding: 1rem 1.5rem 1.5rem;
    text-align: center;
    border-top: 1px solid #eee;

    .footer-cta {
        font-size: .9375rem;
        font-weight: 400;
        color: #333;
        margin-bottom: 1rem;
        line-height: 1.4;
    }

    .whatsapp-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        cursor: pointer;
    }

    .whatsapp-label {
        font-size: .75rem;
        color: #555;
        margin-top: .375rem;
    }

    .option-text {
        font-size: .8125rem;
        color: #555;
    }

    .remind-later {
        display: block;
        margin: 1rem auto 0;
        font-size: .875rem;
        font-weight: 600;
        color: ${theme?.palette.primary.main};
        text-decoration: underline;
        cursor: pointer;
        background: none;
        border: none;
    }
`);

